<template>
  <div :class="{
    'workbench__row': true,
    'workbench__sm_row': isSM
  }">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      isSM: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss">
  .workbench {

    &__row {
      display: flex;
      width: 100%;
      align-items: stretch;

      & + & {
        margin-top: rem(10);
      }
    }

    &__sm_row {
      height: 500px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// WorkbenchRow.vue?f4177bee